(function (angular) {
	angular.module('bizPartEngage').service('core.forgotpasswordService', forgotpasswordService);

	forgotpasswordService.$inject = ["$http", "$rootScope", "bizCoreService"];

	function forgotpasswordService($http, $rootScope, bizCoreService) {
		this.IsResetPasswordGuidValid = function (guid) {
			return $http.get(siteRootPath + 'api/user/IsResetPasswordGuidValid', { params: { guid: guid } });
		}

		this.SendPasswordRecoveryEmail = function (email) {
			return $http.get(siteRootPath + 'api/user/SendPasswordRecoveryEmail', { params: { email: email } });
		};

		this.UpdatePassword = function (guid, newPassword) {
			return $http.post(siteRootPath + 'api/user/UpdatePasswordFromGuid', { guid: guid, newPassword: newPassword });
		};

		this.GetBackgroundImage = function () {
			return bizCoreService.GetPortalsetting("LoginBackgroundImages").then(function (response) {
				var res = response.data;
				var backgroundImages = [];

				images = res.replace(/^(,)+|(,)+$/g, '');

				if (images.length > 0) {
					if (images.indexOf(',') === -1) {
						backgroundImages.push(images);
					}
					else {
						backgroundImages = images.split(',');
					}

					if (backgroundImages.length > 0)
						return backgroundImages[$rootScope.RandomBetween(0, backgroundImages.length - 1)];
				}

				return '';			
			});
		}
	}
})(window.angular);
